<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Driver Fulfillment</span>
      <span class="hidden md:inline body-medium-medium text-light-color">Ride Blueprint</span>
      <app-tag
        [content]="'#' + config.data.rideBlueprintId"
        sizeClass="tag-sm"
        severityClass="secondary"></app-tag>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl mb-spacing-xl border-1 border-neutral-base-primary-border border-round-lg flex flex-column gap-spacing-xl table-bg-hover-bg">
  <h6 class="font-semibold text-xl line-height-3">Filters</h6>
  <form
    [formGroup]="filtersForm"
    class="flex flex-column">
    <div class="grid">
      @for (control of filtersControls; track $index) {
        @if (control.type == tableColumnsType.dropdown) {
          <div class="col-12 md:col-4 form-group mb-spacing-xl">
            <label
              class="input-label label-large-medium text-primary-color mb-spacing-default flex gap-spacing-default align-items-center"
              [for]="control.controlName">
              {{ control.label }}
              @if (control.hint) {
                <span class="label-large-regular text-light-color">{{ control.hint }}</span>
              }
            </label>
            <p-select
              #driverDd
              [id]="control.controlName"
              [readonly]="control.isReadonly"
              [filter]="control.controlName == 'driver'"
              [showClear]="control.controlName == 'driver'"
              filterBy="name"
              [formControlName]="control.controlName"
              appendTo="body"
              [options]="control.controlName == 'driver' ? driversOptions() : control.options || []"
              optionLabel="name"
              [name]="control.controlName"
              [placeholder]="control.controlName == 'driver' ? 'Select a driver' : ''">
              @if (control.controlName == "driver") {
                <ng-template #filter>
                  <div class="flex flex-column gap-spacing-xl">
                    <div class="dropdown-search-box">
                      <div
                        class="p-inputgroup"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="$event.stopPropagation()">
                        <input
                          type="text"
                          pInputText
                          placeholder="Search"
                          [(ngModel)]="filterValue"
                          [ngModelOptions]="{ standalone: true }"
                          (input)="driverDd.filterValue = filterValue; driverDd.onFilter.emit({ originalEvent: $event, filter: filterValue })" />
                        <span class="p-inputgroup-search"><i class="icon-magnifying-glass"></i></span>
                      </div>
                    </div>
                    <div class="camera-filters">
                      <ul class="list-none m-0 p-0 flex gap-spacing-sm">
                        @for (filter of cameraStatusFilters; track $index) {
                          <li>
                            <button
                              (click)="updateCameraStatusFilter(filter.code)"
                              class="label-medium-regular py-spacing-2xs px-spacing-md radius-full border-none"
                              [ngClass]="{
                                'table-bg-head-hover-bg': !filter.selected,
                                'background-muted-brand-bg': filter.selected
                              }">
                              {{ filter.name }}
                            </button>
                          </li>
                        }
                      </ul>
                    </div>
                  </div>
                </ng-template>
                <ng-template
                  let-driver
                  #item>
                  <div class="flex justify-content-between align-items-start w-full">
                    <div class="flex flex-column gap-spacing-3xs">
                      <div class="title-small-medium">{{ driver.name }}</div>
                      <div class="flex gap-spacing-2xs">
                        <span>{{ driver.organization }}</span>
                        <span>|</span>
                        <span>{{ driver.mobileNumber }}</span>
                      </div>
                    </div>
                    <span
                      [pTooltip]="
                        (!driver.cameraStatus?.camera_id ? 'Not Installed' : driver.cameraStatus?.camera_online_status ? 'Active' : 'Offline') +
                        (driver.cameraStatus?.last_sync_date ? ' - Last Sync ' + (driver.cameraStatus.last_sync_date | date: 'h:mm a') : '')
                      "
                      tooltipPosition="bottom"
                      [autoHide]="false"
                      class="flex align-items-center gap-spacing-3xs p-spacing-3xs border-1 border-round-sm"
                      [ngClass]="{
                        'icon-lightest-color icon-lightest-border': driver.cameraStatus?.camera_id && !driver.cameraStatus?.camera_online_status,
                        'icon-danger-color icon-danger-border': !driver.cameraStatus?.camera_id,
                        'icon-success-subtle-color icon-success-subtle-border': driver.cameraStatus?.camera_id && driver.cameraStatus?.camera_online_status
                      }">
                      <i
                        class="size-icon-sm"
                        [ngClass]="{
                          'icon-video-camera-solid': driver.cameraStatus?.camera_id,
                          'icon-video-camera-slash-solid': !driver.cameraStatus?.camera_id
                        }"></i>
                    </span>
                  </div>
                </ng-template>
              }
            </p-select>
          </div>
        }
      }
    </div>

    <div class="flex justify-content-center align-items-center advanced-filters-btn-container mb-spacing-xl">
      <app-button
        (btnClick)="toggleAdvancedFilters()"
        label="Advanced Filters"
        iconEnd="icon-caret-up-down"
        [textButton]="true"
        sizeClass="p-button-md"
        severity="primary"></app-button>
    </div>

    <div
      class="grid"
      stCollapsible
      [isCollapsed]="showAdvancedFilters">
      @for (control of advancedFiltersControls; track $index) {
        @if (control.type == tableColumnsType.dropdown) {
          <div class="col-12 md:col-4 form-group mb-spacing-xl">
            <label
              class="input-label label-large-medium text-primary-color mb-spacing-default flex gap-spacing-default align-items-center"
              [for]="control.controlName"
              >{{ control.label }}</label
            >
            <p-select
              [id]="control.controlName"
              [readonly]="control.isReadonly"
              [formControlName]="control.controlName"
              appendTo="body"
              [options]="control.options || []"
              optionLabel="name"
              [name]="control.controlName" />
          </div>
        }
        @if (control.type == tableColumnsType.number) {
          <div class="col-12 md:col-4 form-group mb-spacing-xl">
            <label
              class="input-label label-large-medium text-primary-color mb-spacing-default flex gap-spacing-default align-items-center"
              [for]="control.controlName"
              >{{ control.label }}</label
            >
            <div class="k-input-wrapper">
              <p-inputNumber
                class="w-full p-inputtext-md"
                [formControlName]="control.controlName"
                [name]="control.controlName"
                [id]="control.controlName"
                [inputId]="control.controlName"
                placeholder="0"
                [style]="{ width: '100%' }"
                [min]="0" />
              <span class="capitalize absolute right-0 pr-spacing-xl">{{ control.unitOfMeasure }}</span>
            </div>
          </div>
        }
      }
    </div>
  </form>

  <div class="flex justify-content-between gap-spacing-xs align-items-center">
    <p-selectButton
      [unselectable]="true"
      class="p-button-sm"
      [options]="viewsOptions"
      [(ngModel)]="selectedView"
      optionLabel="name"
      optionValue="id">
      <ng-template
        let-item
        #item>
        <div class="flex align-items-center gap-spacing-xs">
          <i [class]="item.icon + ' size-icon-sm'"></i>
          <span>{{ item.name }}</span>
        </div>
        <span></span>
      </ng-template>
    </p-selectButton>
    <app-button
      (btnClick)="calcMatchPercent()"
      [isLoading]="loading"
      [iconStart]="loading ? 'icon-spinner-gap' : ''"
      [disabled]="!filtersForm.valid || loading"
      label="Search"
      sizeClass="p-button-md"
      severity="primary"></app-button>
  </div>

  <!-- @if (selectedView == 2) { -->
  <div
    class="map find-driver-map"
    [ngClass]="{ hidden: selectedView != 2 }">
    <app-drivers-map
      (assign)="openAssignSubDriverDialog($event.partnerId)"
      (hideFromSearch)="hideDriverFromResults($event)"
      [viewLatestLocation]="filtersForm.value.driverBaseLocation.name == 'Last Active Location'"
      [latestLocations]="driverFirestoreLocations()"
      [updatedDriverLocation]="updatedDriverLocation()"
      [drivers]="filteredDrivers()"></app-drivers-map>
  </div>
  <!-- } -->

  @if (selectedView == 1) {
    @if (filteredDrivers().length > 0) {
      <p-table
        #table
        [value]="filteredDrivers()"
        [columns]="columns"
        dataKey="id"
        [rows]="rows"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [loading]="loading"
        [paginator]="true"
        [(first)]="first"
        [totalRecords]="totalRecords"
        (onPage)="onPage($event)"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [scrollable]="true"
        [tableStyleClass]="'table-main-mode border-round-lg'">
        <ng-template
          #header
          let-columns>
          <tr>
            <th
              class="index"
              scope="col">
              #
            </th>
            @for (col of columns; track col) {
              <th scope="col">
                <span class="content w-auto text-md font-semibold">{{ col.name }}</span>
              </th>
            }
            <th scope="col">
              <span class="content w-auto text-md font-semibold">Action</span>
            </th>
          </tr>
        </ng-template>
        <ng-template
          #body
          let-rowData
          let-columns="columns"
          let-index="rowIndex">
          <tr>
            <td class="index">{{ index + 1 }}</td>
            @for (col of columns; track col) {
              <td>
                @if (col.field != "status" && col.field != "bestMatch" && col.field != "driver") {
                  <span class="content text-secondary-color">{{ rowData[col.field] }}</span>
                } @else if (col.field == "status") {
                  <div
                    class="content inline-block px-2"
                    [pTooltip]="statusTooltip"
                    tooltipStyleClass="dark-arrow-tooltip"
                    tooltipPosition="left"
                    [autoHide]="false">
                    <app-tag
                      [content]="rowData[col.field]"
                      styleClass="bold"
                      sizeClass="tag-sm"
                      [severityClass]="rowData['bestMatch'] == 100 ? 'success' : rowData['bestMatch'] < 100 && rowData['bestMatch'] > 50 ? 'warning' : 'danger'">
                    </app-tag>
                  </div>
                } @else if (col.field == "bestMatch") {
                  <div
                    class="content inline-block font-medium px-2"
                    [pTooltip]="statusTooltip"
                    tooltipStyleClass="dark-arrow-tooltip"
                    tooltipPosition="right"
                    [autoHide]="false">
                    <span
                      [ngClass]="{
                        'text-success-subtle-color': +rowData[col.field] == 100,
                        'text-warning-color': +rowData[col.field] < 100 && +rowData[col.field] > 50,
                        'text-danger-color': +rowData[col.field] <= 50
                      }"
                      >{{ rowData[col.field] }}%
                    </span>
                  </div>
                } @else if (col.field == "driver") {
                  <div class="content">
                    <div class="flex gap-spacing-xs">
                      <span class="text-secondary-color text-md">{{ rowData["fullName"] }}</span>
                      <span class="text-lightest-color text-sm">#{{ rowData["partnerId"] }}</span>
                    </div>
                    <span class="text-lightest-color text-sm">{{ rowData["organization"] }}</span>
                  </div>
                }
                <ng-template #statusTooltip>
                  <div class="tooltip-body">
                    <div class="item">
                      <span class="border-neutral-base-primary-color flex align-items-center">
                        <i
                          class="text-xl mr-spacing-2xs"
                          [ngClass]="{
                            'icon-check-circle-solid icon-success-subtle-color': rowData.status == 'Available',
                            'icon-warning-solid': rowData.status == 'Attention',
                            'feedback-warning-fg-color': rowData.bestMatch < 100 && rowData.bestMatch > 50,
                            'feedback-danger-fg-color': rowData.bestMatch <= 50
                          }">
                        </i>
                        {{ rowData.status == "Attention" ? "Attention Needed" : "100% Match" }}
                      </span>
                    </div>
                    <div class="item">
                      <ul class="mb-0 pl-spacing-3xl">
                        @if (rowData.moreInfo.reasons.length == 0) {
                          <li>This driver matches this route</li>
                        }
                        @for (reason of rowData.moreInfo.reasons; track $index) {
                          <li>{{ reason.details }}</li>
                        }
                      </ul>
                    </div>
                  </div>
                </ng-template>
              </td>
            }
            <td>
              <div>
                <p-menu
                  #menuRef
                  [appendTo]="'body'"
                  [model]="menuItems()"
                  [popup]="true" />
                <app-button
                  (btnClick)="setMenu($event, rowData, menuRef)"
                  [iconOnlyButton]="true"
                  icon="icon-list"
                  sizeClass="p-button-sm"
                  severity="primary"
                  [outlinedButton]="true"></app-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    } @else {
      <app-no-records></app-no-records>
    }
  }
</div>
